<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('currency.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('currency.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              v-tooltip="$t('currency.search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
            <td>{{ record.currency_code }}</td>
            <td>{{ record.currency_description }}</td>
            <td class="ts-text-center">{{ record.currency_symbol }}</td>
            <td>{{ record.currency_rounding }}</td>
            <td class="ts-text-center">
                <span class="badge badge-success" v-if="record.is_default">Yes</span>
                <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="text-center ts-space-x-3">
                <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
                >
                <i class="fas fa-edit"></i>
                </a>
            </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('currency.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'exchangeRateIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('exchangeRate/currency', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.currency.search
      },
      set(newValue) {
        this.$store.commit('exchangeRate/currency/SET_SEARCH', newValue)
        this.$store.commit('exchangeRate/currency/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('currency.code') },
        { name: this.$t('currency.description') },
        { name: this.$t('currency.symbol'), style: 'text-align:center' },
        { name: this.$t('currency.rounding') },
        { name: this.$t('currency.default'), style: 'text-align:center' },
				{ name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currency/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
		edit(record) {
      this.$store.commit('exchangeRate/currency/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('exchangeRate/currency/SET_EDIT_DATA', {})
      this.showForm = false
		}
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('exchangeRate/currency/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
